export default __webpack_public_path__ + "media/flags/sc-44e67156.svg";